module.exports = __webpack_public_path__ + "static/img/fail-wap.36206137.png";